import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 10fr;
  color: #fff;
`;

export const LabelSla = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  div {
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
    p {
      display: inline-block;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
    }
  }
`;

export const FirstSla = styled.div`
  padding: 8px;
  border-right: dashed 1px #fff;
  background-color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px 0 0 4px;
  .span {
    padding-right: 8px;
  }

  .resultSla {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .sla1 {
      margin-right: 15px;
    }
  }
`;

export const Title = styled.h2`
  margin: 0;
  padding-left: 16px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
`;

export const SecondSla = styled.div.attrs((props: any) => ({
  width: props.width,
  color: props.color,
}))`
  width: ${(props) => props.width}%;
  padding: 8px;
  background-color: ${(props: any) => props.color};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 0 4px 4px 0;
  .span {
    padding-right: 8px;
  }

  .percentage {
    display: flex;
    align-items: center;
    /* font-size: 16px;
    color: #fff;
    font-weight: 600; */
  }
`;

export const Time = styled.time`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding-right: 16px;

  display: flex;
  width: 100%;
  justify-content: center;

  .clock {
    margin-left: 5px;
  }
`;

export const Border = styled.div.attrs((props: any) => ({
  color: props.color,
}))`
  background-color: transparent;
  border: 1px solid ${(props: any) => props.color};
  border-radius: 0 4px 4px 0;
  width: 100%;
  padding: 0;
  margin: 0;
`;
